class WLMHideRapidSearch {
    constructor() {
        this.collectionContainer = ".rps-results";
        this.collectionProductWrapper = "a.rps-product-container";
        this.searchContainer = "#rapid-search-results";
        this.searchProductWrapper = ".rps_product_block .rps_list_item";
        // add observer 
        this.observeHead();
    }

    // observer
    observeHead() {
        let _this = this;  
      
        // remove products from collection and search page
        let collectionIntevalCount = 0;
        let collectionContainer = null;
        let collectionObserverTimeout = setInterval(function (data) {        
              collectionIntevalCount++;
              if(collectionIntevalCount > 5){
                clearInterval(collectionObserverTimeout);
              }
              collectionContainer = document.querySelectorAll(_this.collectionContainer);              
              if (collectionContainer != null && collectionContainer.length > 0) {                                    
                  clearInterval(collectionObserverTimeout);              
                  const observerSearch = new MutationObserver((mutations) => {
                      let products = _this.getProductList("COLLECTION"); 
                      //console.log(products);
                      _this.checkIsProductHide(products,"COLLECTION");  
                  });                
                  for (var j = 0; j < collectionContainer.length; j++) {
                      observerSearch.observe(collectionContainer[j], {
                          subtree: true,
                          childList: true,
                      });
                  }
              }
          }, 500);    

        // remove products from the search popup
        let searchIntevalCount = 0;
        let searchContainer = null;
        let searchObserverTimeout = setInterval(function (data) {        
              searchIntevalCount++;
              if(searchIntevalCount > 10){
                clearInterval(searchObserverTimeout);
              }
              searchContainer = document.querySelectorAll(_this.searchContainer);              
              if (searchContainer != null && searchContainer.length > 0) {  
                  clearInterval(searchObserverTimeout);              
                  const observerSearch = new MutationObserver((mutations) => {
                      let products = _this.getProductList("SEARCH"); 
                      //console.log(products);
                      _this.checkIsProductHide(products,"SEARCH");  
                  });                
                  for (var j = 0; j < searchContainer.length; j++) {
                      observerSearch.observe(searchContainer[j], {
                          subtree: true,
                          childList: true,
                      });
                  }
              }
          }, 500);    
    }

    // Get products html element
    getProductList(searchType) {
        const productList = [];   
        let productEls = [];
        if(searchType == "COLLECTION"){
          productEls = document.querySelector(this.collectionContainer).querySelectorAll(this.collectionProductWrapper);  
          productEls.forEach((productEl) => {
            const handle = this.getHandleFromProductUrl(productEl.href);
            productList.push(handle);
          });
        }else if(searchType == "SEARCH"){
          productEls = document.querySelector(this.searchContainer).querySelectorAll(this.searchProductWrapper);            
          productEls.forEach((productEl) => {
            const handle = productEl.getAttribute("data-handle");
            productList.push(handle);
          });
        }
        return productList;
    }

    // Get product handle from the URL
    getHandleFromProductUrl(url = null) {
        if (url === null) {
            url = this.currentUrl();
        }
        const tempEl = document.createElement("a");
        tempEl.href = url;
        const matches = tempEl.pathname.match("/products/(.*)");
        return matches && matches.length > 1 && matches[1];
    }
  
    // remove html 
    RemoveHideProducts(searchType) {
        const products = this.getProductEls(searchType);
        let handle = [];
        products.forEach((productLiEl) => {
           if(searchType == "COLLECTION"){
             handle = this.getHandleFromProductUrl(productLiEl.href);
           }else if(searchType == "SEARCH"){
             handle = productLiEl.getAttribute("data-handle");
           }
          var isHide = this.customFind(window.wlm_local_data.hideProductPayload.products, function (LocalProduct) {
              return handle == LocalProduct.handle;
          });
          if (isHide == undefined) {
              productLiEl.style.display="none";
          }
       });
    }

    // Get html of all products
    getProductEls(searchType) {
        if(searchType == "COLLECTION"){
            return document.querySelector(this.collectionContainer).querySelectorAll(this.collectionProductWrapper);  
        }
        else if(searchType == "SEARCH"){
          return document.querySelector(this.searchContainer).querySelectorAll(this.searchProductWrapper);
        }       
    }
  
     // Made request to wlm api and call hide products function
    checkIsProductHide(handles = [],searchType) {      
        var _this = this;
        if (!handles) {
            return;
        }
        if (handles.length == 0 && window.wlm_local_data.hideProductPayload == undefined) {
            return;
        }
        const filteredHandles = handles.filter((handle) => {
            if (!window.wlm_local_data.hideProductPayload) {
                return true;
            }

            if (!handle) {
                return false;
            }

            let checkHandle = this.customFind(window.wlm_local_data.hideProductPayload.products, function (product) {
                return product.handle == handle;
            });

            if (checkHandle == undefined) {
                return true;
            } else {
                return false;
            }
        });

        if (filteredHandles.length === 0) {
            this.RemoveHideProducts(searchType);
            return Promise.resolve();
        }


        const maxHandleLimit = 20;
        let from = 0;
        let left = filteredHandles.length;
        let to = maxHandleLimit;

        do {
            let paged = filteredHandles.slice(from, to);
            const url = `/search?view=wlm-api&handle=${paged.join(",")}`;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var json = JSON.parse(this.responseText);
                    _this.saveWLMHideProductLocally(json);
                }
            }
            xhttp.open("GET", url, false);
            xhttp.send();

            from = to;
            to += maxHandleLimit;
            left -= maxHandleLimit;
        } while (left >= 0);
        this.RemoveHideProducts(searchType);
    }
  
    // Add products to the window object to save request and for later use
    saveWLMHideProductLocally(json) {
        if (!window.wlm_local_data.hideProductPayload) {
            window.wlm_local_data.hideProductPayload = json;
        } else if (json.products.length) {
            // need to be create unique array
            window.wlm_local_data.hideProductPayload.products = [].concat(
                window.wlm_local_data.hideProductPayload.products,
                json.products
            );

        }

    }

    // Custom function that work as arrow find jQuery function
    customFind(arr, callback) {
        for (var i = 0; i < arr.length; i++) {
            var match = callback(arr[i]);
            if (match) {
                return arr[i];
                break;
            }
        }
    }
   
}
window.wlm_local_data = {}
WLMHideRapidSearch = new WLMHideRapidSearch();